export default {"src":"/_next/static/media/bpt.cafe3f9d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};